enum SplitNames {
  DisplayAppBanner = 'DISPLAY_APP_BANNER',
  AssemblyV3Experience = 'ASSEMBLY_V3',
  EnableUserActivitiesTracking = 'ENABLE_USER_ACTIVITIES_TRACKING',
  LocationCriteria = 'LOCATION_CRITERIA',
  MultiPopoutDrawer = 'MULTI_POPOUT_DRAWER',
  FlowSummaries = 'FLOW_SUMMARIES_V0',
  CONVERTED_PDF_PREVIEWS = 'CONVERTED_PDF_PREVIEWS',
  DisableRewards = 'DISABLE_TANGO_REDEMPTION',

  // Used to enforce V3 experience for customers created before Oct 26th
  EnforceV3Experience = 'ENFORCE_V3_EXPERIENCE',

  HideV2DirectMessaging = 'HIDE_V2_DM',
  RepliesV3 = 'REPLIES_V3',
  EnableAssemblyMagicLink = 'ASSEMBLY_MAGIC_LINK',
  ShowNotebook = 'SHOW_NOTEBOOK',
}

enum TreatmentTypes {
  CONTROL = 'control',
  ON = 'on',
  OFF = 'off',
  NOT_YET_SET = 'NOT_YET_SET',
}

export { SplitNames, TreatmentTypes };
